import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import ScrollToTopButton from "@/components/ScrollToTopButton";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Ministries from "@/pages/Ministries";
import MinistryDetail from "@/pages/MinistryDetail";
import Events from "@/pages/Events";
import Sermons from "@/pages/Sermons";
import Giving from "@/pages/Giving";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Booking from "@/pages/Booking";
import NewMember from "@/pages/NewMember";
import Volunteer from "@/pages/Volunteer";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ConnectWithUs from "@/pages/ConnectWithUs";
import MemberSignup from "@/pages/MemberSignup";
import MemberLogin from "@/pages/MemberLogin";
import VerifyEmail from "@/pages/VerifyEmail";
import PortalLayout from "@/components/PortalLayout";
import PortalDashboard from "@/pages/PortalDashboard";
import PortalGroups from "@/pages/PortalGroups";
import PortalGroupDetail from "@/pages/PortalGroupDetail";
import MemberProtectedRoute from "@/components/MemberProtectedRoute";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <a
              href="#main-content"
              className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-electric focus:text-black focus:px-4 focus:py-2 focus:rounded-full focus:font-bold focus:text-sm"
              data-testid="skip-to-content"
            >
              Skip to content
            </a>
            <Toaster
              theme="dark"
              position="top-right"
              toastOptions={{
                style: {
                  background: "#0a0a0a",
                  border: "1px solid rgba(34,197,94,0.3)",
                  color: "#fff",
                },
              }}
            />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/ministries" element={<Ministries />} />
              <Route path="/ministries/:slug" element={<MinistryDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/sermons" element={<Sermons />} />
              <Route path="/giving" element={<Giving />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/new-members" element={<NewMember />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/connect" element={<ConnectWithUs />} />
              <Route path="/signup" element={<MemberSignup />} />
              <Route path="/login" element={<MemberLogin />} />
              <Route path="/verify" element={<VerifyEmail />} />
              <Route
                path="/portal"
                element={
                  <MemberProtectedRoute>
                    <PortalLayout />
                  </MemberProtectedRoute>
                }
              >
                <Route index element={<PortalDashboard />} />
                <Route path="groups" element={<PortalGroups />} />
                <Route path="groups/:slug" element={<PortalGroupDetail />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Footer />
            <ScrollToTopButton />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
